import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { Layout } from 'containers';
import { Breadcrumb, FeatherIcon, Loader } from 'components';
import { ManufacturersProvider } from 'providers';

const Makes = () => {
    const [ pageLoading, setPageLoading ] = useState(true);
    const [ filteredBrands, setFilteredBrands ] = useState([]);
    const [ brands, setBrands ] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
            const brands = await ManufacturersProvider.getAll();
            setBrands(brands.results);
            setFilteredBrands(brands.results);
            setPageLoading(false);
		};
		fetchData();
    }, [ setBrands, setFilteredBrands, setPageLoading ]);

    const handleFilter = val => {
        const filtered = brands.filter(item => item.description.toLowerCase().indexOf(val.toLowerCase()) !== -1);
        setFilteredBrands(filtered);
    };

    return (
        <Layout>
			{pageLoading && <Loader />}
			<Breadcrumb
                title="Manage Makes"
			/>
            <Row className="inbox-wrapper">
                <Col lg={12}>
                    <Card>
                        <CardBody>
                            <Row>
                                <Col lg={12} className="email-content">
                                    <div className="email-inbox-header">
                                        <Row className="row align-items-center">
                                            <Col lg={6}>
                                                <div className="email-title mb-2 mb-md-0">
                                                    <span className="icon">
                                                        <FeatherIcon icon="database" />
                                                    </span> Vehicle Makes
                                                </div>
                                            </Col>
                                            <Col lg={6}>
                                                <div className="email-search">
                                                    <div className="input-group input-search">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="Search makes..."
                                                            onKeyUp={e => handleFilter(e.target.value)}
                                                        />
                                                        <span className="input-group-btn">
                                                            <button className="btn btn-outline-secondary" type="button">
                                                                <FeatherIcon icon="search" />
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div>
                                        {filteredBrands.length > 0 && filteredBrands.map((item, idx) => (
                                        <a
                                            key={item.id}
                                            href={`/vehicles/makes/${item.id}`}
                                            className={`d-flex align-items-center border-bottom ${idx === 0 ? 'pb-3' : 'py-3'}`}
                                            onClick={e => e.preventDefault()}
                                        >
                                            <div className="mr-3">
                                                <img src={require("images/faces/face2.jpg")} className="rounded-circle wd-35" alt={item.description} />
                                            </div>
                                            <div className="w-100">
                                                <div className="d-flex justify-content-between">
                                                    <h6 className="text-body mb-2">{item.description}</h6>
                                                    <p className="text-muted tx-12">{item.primary_color}</p>
                                                </div>
                                                <p className="text-muted tx-13">{item.long_description}</p>
                                            </div>
                                        </a>))}
                                        {filteredBrands.length === 0 && <div className="text-center">No match for specified filter</div>}
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default Makes;
